import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";

const Login = () => {

	const {
	  isAuthenticated,
	  loginWithRedirect,
	  //logout,
	} = useAuth0();

	/**
	 * componentDidMount hook
	 */ 
	useEffect(() => {
	  document.body.classList.add('page-template-login-page');

	  // returned function will be called on component unmount 
	  return () => {
	    document.body.classList.remove('page-template-login-page');
	  }
	}, [])


	return (
		<div className="login-split-view">


			<div className="login-split-view-main">

				<div className="login-split-view-main-content">
					
					<div className="login-logo">
						<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 512 512"><style>{'.st0,.st3{fill:#fff}.st3{opacity:.68;enable-background:new'}</style><path id="Path_65" className="st0" d="M254.3 418.6c-89.7-.1-162.3-72.9-162.2-162.5.1-89.7 72.8-162.3 162.5-162.2 89.7.1 162.3 72.8 162.2 162.5 0 43-17.2 84.3-47.6 114.7-30.5 30.4-71.8 47.5-114.9 47.5zm0-300.6c-36.7-.1-71.8 14.5-97.7 40.4-54.1 54-54.2 141.6-.2 195.7s141.6 54.2 195.7.2 54.2-141.6.2-195.7c-26-26-61.3-40.6-98-40.6z"/><path id="Path_66" d="M203.1 456.8c-1.1 0-2.1-.1-3.2-.4C89.3 426.3 24 312.2 54.1 201.6c17-62.4 62.1-113.4 122.1-137.8 6.2-2.5 13.3.5 15.8 6.7s-.5 13.3-6.7 15.8c-93.8 38.1-138.9 145-100.8 238.8 21.5 53 66.5 92.8 121.7 107.8 6.5 1.7 10.4 8.3 8.7 14.8-1.3 5.5-6.2 9.2-11.8 9.1z" opacity=".58" fill="#fff"/><path id="Path_67" className="st0" d="M203.1 456.8c-1.1 0-2.1-.1-3.2-.4C120 434.7 60.6 367.5 48.8 285.5c-.8-6.7 4-12.7 10.7-13.4 6.4-.7 12.3 3.7 13.3 10 10.4 72.4 62.8 131.7 133.3 150.9 6.5 1.7 10.4 8.3 8.7 14.8-1.3 5.4-6.2 9.1-11.7 9z"/><path id="Path_68" className="st0" d="M59.9 248.8c-.4 0-.8 0-1.2-.1-6.7-.7-11.5-6.6-10.9-13.3C51.7 196.2 66.7 159 91 128.1c4.3-5.1 12-5.8 17.1-1.5 4.9 4.1 5.8 11.3 2 16.5-21.5 27.3-34.7 60.2-38.1 94.8-.6 6.2-5.8 10.9-12.1 10.9z"/><path id="Path_69" className="st0" d="M288.4 75.9c-.7 0-1.4-.1-2.1-.2-11.9-2.1-24-3-36.1-2.8-6.7 0-12.1-5.4-12.2-12.1 0-6.5 5.1-11.9 11.6-12.1 13.7-.3 27.4.8 40.8 3.1 6.6 1.1 11 7.4 9.9 14-.9 5.8-6 10.1-11.9 10.1z"/><path id="Path_70" className="st0" d="M288.2 460.7c-6.7 0-12.1-5.5-12.1-12.2 0-5.8 4.2-10.8 10-11.9 99.7-17.7 166.2-112.8 148.5-212.5-10.6-60-50.4-110.8-106.1-135.5-6.1-2.9-8.7-10.1-5.8-16.2 2.8-5.9 9.6-8.5 15.6-6 104.8 46.4 152.1 169 105.7 273.8-28 63.2-85.6 108.3-153.6 120.3-.7.1-1.4.2-2.2.2z"/><path id="Path_71" d="M254.3 509.3c-123.4.1-228.9-88.8-249.7-210.4-1.5-6.5 2.6-13.1 9.1-14.6s13.1 2.6 14.6 9.1c.1.5.2.9.2 1.4 21.4 124.7 139.8 208.4 264.5 187C417.7 460.4 501.4 342 480 217.3 458.5 92.7 340.1 9 215.5 30.4c-23.6 4.1-46.5 11.8-67.7 22.9-5.9 3.1-13.3.8-16.4-5.1s-.8-13.3 5.1-16.4c123.8-65.1 277-17.5 342.1 106.3 65.1 123.8 17.5 277-106.3 342.1-36.4 19.1-76.9 29.1-118 29.1z" opacity=".48" fill="#fff"/><path id="Path_72" className="st3" d="M492.4 306.9c-6.7 0-12.2-5.5-12.1-12.2 0-.6.1-1.2.1-1.9 14.4-88.9-24.6-177.9-99.6-227.7-5.7-3.5-7.4-11-3.9-16.7 3.5-5.7 11-7.4 16.7-3.9.2.1.4.3.6.4 82.9 55.1 126 153.5 110.1 251.8-.9 5.9-6 10.2-11.9 10.2z"/><path id="Path_73" className="st3" d="M254.3 509.3c-101.6.1-193.4-60.6-233.2-154-2.6-6.2.3-13.3 6.4-15.9 6.2-2.6 13.3.3 15.9 6.4C93 462.2 227.7 516.4 344.1 466.7c49.1-20.9 89.3-58.3 113.7-105.7 3.1-6 10.4-8.3 16.4-5.2 6 3.1 8.3 10.4 5.2 16.4-43.4 84.3-130.3 137.2-225.1 137.1z"/><path id="Path_74" className="st0" d="M32.3 173.9c-6.7 0-12.1-5.4-12.1-12.2 0-1.6.3-3.2 1-4.7 7.4-17.5 16.8-34 27.9-49.4 3.9-5.4 11.5-6.6 16.9-2.7 5.4 3.9 6.6 11.5 2.7 16.9-10.1 13.9-18.5 28.9-25.3 44.6-1.8 4.6-6.2 7.5-11.1 7.5z"/></svg>
					</div>

					<h1 className="login-title">RENÈ</h1>

					<div className="login-description">
						<p>Business intelligence and performance analytics for restaurants.</p>
						<p>Get a better understanding of what drives your revenue through performance statistics, menu engineering analytics salary costs.</p>
						<p>Integrate directly with OnlinePOS, OrderYOYO, Wolt, Planday and more</p>
					</div>

					{isAuthenticated && (
						<Link className="button button--light button--wide" activeClassName="current-menu-item" to="/dashboard">Go to dashboard</Link>
					)}

					{!isAuthenticated && (
						<button className="button button--light button--wide" onClick={ () => loginWithRedirect({})}>Login</button>
					)}

				</div>

			</div>

			<div className="login-split-view-side">
				
			</div>
			
		</div>
	);
};

export default Login;